<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="message_template"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @editMessageTemplate="editMessageTemplate"
        >
            <slot slot="filter">
                <el-col :md="6" :xl="4" class="padding-right10">
                    <item-input type="groupselect" v-model="dic_ward_id" :clearable="true" :options="searchlocation" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" size="mini" v-has-permission="createPermission" @click="addMessageTemplate">创建</el-button>
            </template>
        </crud-facecade>
        <form-dialog
            :title="messageTemplateView.title"
            :visible.sync="messageTemplateView.dialogFormVisible"
            :data="messageTemplateView.data"
            :columns="messageTemplateView.columnList"
            width="50%"
            @confirm="saveOne"
        >
        </form-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `MessageTemplate`,
    props: {
    },
    data() {
        return {
            title: `消息模板`,
            url: {
                baseURL: `/api/AcisSystem/BoardTemplate`,
                get: () => {
                    return this.ReloadListData()
                }
            },
            dic_ward_id: undefined,
            usergroup: [],
            users: [],
            buttons: [],
            messageTemplateView: {
                title: `创建`,
                dialogFormVisible: false,
                columnList: [],
                data: {}
            },
            sendType: 1,
            createPermission: `message_template_add` // 新增权限
        }
    },
    created() {
        this.loadUsers()
        this.loadGroup()
    },
    computed: {
        ...mapGetters([`screenHeight`, `ward_auth`, `sys_enums`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 175) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `序号`,
                isListable: false,
                isEditable: false,
                isCreatable: false,
                isKey: true,
                colspan: 24
            }, {
                type: `string`,
                prop: `name`,
                label: `模板名称`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                rowspan: 1,
                colspan: 24,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `title`,
                label: `消息标题`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                rowspan: 1,
                colspan: 24,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `textarea`,
                prop: `content`,
                label: `消息内容`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                rowspan: 1,
                colspan: 24,
                config: {
                    minRows: 4
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `radio`,
                prop: `send_type`,
                label: `通知形式`,
                rowspan: 1,
                colspan: 24,
                isListable: false,
                isCreatable: true,
                isEditable: true,
                default: 1,
                options: [{ label: `播报`, value: 1 }, { label: `信息`, value: 2 }],
                change: (that, { row }) => {
                    if (row.send_type == 2) {
                        this.$set(row, `dic_ward_ids`, null)
                        this.$set(row, `dic_operating_ward_id`, null)
                        this.$set(row, `dic_operating_room_id`, null)
                        this.$set(row, `dic_recovery_ward_id`, null)
                        this.$set(row, `dic_recovery_bed_id`, null)
                        this.$set(row, `board_type`, null)
                        this.$set(row, `play_time`, null)
                        this.$set(row, `play_interval`, null)
                    } else {
                        this.$set(row, `all`, false)
                        this.$set(row, `sys_messagegroup_ids`, null)
                        this.$set(row, `ac_sysUser_ids`, null)
                    }
                    this.changeShowColumnList(row.send_type)
                }
            }, {
                type: `selecttree`,
                prop: `dic_ward_ids`,
                label: `显示位置`,
                rowspan: 1,
                colspan: 24,
                isListable: true,
                searchable: false,
                sendType: 1,
                options: this.loadnoticelocation,
                collapseTags: false,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `integer`,
                prop: `play_time`,
                label: `播放次数`,
                rowspan: 1,
                colspan: 12,
                sendType: 1
            },
            {
                type: `integer`,
                prop: `play_interval`,
                label: `播放间隔(秒)`,
                rowspan: 1,
                colspan: 12,
                sendType: 1
            },

            {
                type: `checkbox`,
                prop: `all`,
                label: `全部`,
                rowspan: 1,
                colspan: 24,
                sendType: 2
            },
            {
                type: `multiselect`,
                prop: `sys_messagegroup_ids`,
                label: `接收组`,
                options: this.usergroup,
                rowspan: 1,
                colspan: 12,
                sendType: 2,
                showCount: 3,
                collapseTags: false
            }, {
                type: `multiselect`,
                prop: `ac_sysUser_ids`,
                label: `接收人`,
                options: this.users,
                rowspan: 1,
                colspan: 12,
                showCount: 10,
                collapseTags: false,
                sendType: 2
            },
            {
                type: `string`,
                prop: `modify_date`,
                label: `最后修改时间`,
                isListable: true,
                isEditable: false,
                isCreatable: false
            }, {
                type: `string`,
                prop: `modifier`,
                label: `最后修改人`,
                isListable: true,
                isEditable: false,
                isCreatable: false
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `100`,
                readonly: false,
                isListable: true,
                options: [{
                    class: `is-plain`,
                    label: `编辑`,
                    type: `primary`,
                    emit: `editMessageTemplate`,
                    permission: `message_template_edit`
                }, {
                    class: `is-plain`,
                    label: `删除`,
                    type: `danger`,
                    emit: `DeleteData`,
                    permission: `message_template_delete`,
                    isListable: true
                }]
            }]
        },
        loadnoticelocation() {
            let options = []
            options.push({
                label: `显示屏`,
                value: `dp_xsp_1`,
                jianpin: `xsp`,
                code: `xsp`,
                children: [{
                    label: `排程屏`,
                    value: `dp_pc_1`,
                    jianpin: `pcp`,
                    code: `pcp`,
                    parent_value: `dp_xsp_1`
                }]
            })
            this.ward_auth.map(ward => {
                let wardoption = {
                    label: `${ward.label}`,
                    value: `${ward.value}`,
                    jianpin: `${ward.jianpin}`,
                    code: `${ward.code}`
                }
                let children = []
                if (ward.operation_room && ward.operation_room.length > 0) {
                    ward.operation_room.map(room => {
                        children.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            parent_value: `${ward.value}`
                        })
                    })
                } else if (ward.recovery_bed && ward.recovery_bed.length > 0) {
                    ward.recovery_bed.map(room => {
                        children.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            parent_value: `${ward.value}`
                        })
                    })
                }
                if (children.length > 0) {
                    wardoption.children = children
                }
                options.push(wardoption)
            })
            return options
        },
        searchlocation() {
            let options = []
            options.push({
                label: `排程屏`,
                value: `dp_pc_1`,
                jianpin: `pcp`,
                code: `pcp`,
                group: `显示屏`
            })
            this.ward_auth.map(ward => {
                if (ward.operation_room && ward.operation_room.length > 0) {
                    ward.operation_room.map(room => {
                        options.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            group: ward.label
                        })
                    })
                } else if (ward.recovery_bed && ward.recovery_bed.length > 0) {
                    ward.recovery_bed.map(room => {
                        options.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            group: ward.label
                        })
                    })
                }
            })
            return options
        }
    },
    mounted() {

    },
    methods: {
        loadUsers() {
            let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
            req.then((data) => {
                this.users = _.map(data, d => {
                    return {
                        value: d.id,
                        label: d.dic_worker_name || `--`,
                        code: d.username,
                        disabled: d.is_deleted
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadGroup() {
            let req = this.myaxios.get(`/api/AcisSystem/MessageGroup/Get`)
            req.then(data => {
                this.usergroup = data && data.map(d => {
                    return {
                        label: d.name,
                        value: d.id,
                        ac_sys_user_id: d.ac_sys_user_id
                    }
                })
            })
        },
        ReloadListData() {
            let that = this
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/BoardTemplate/Get`)
                req.then(data => {
                    _.map(data, d => {
                        let roomIds = d.dic_operating_room_id && _.split(d.dic_operating_room_id, `,`).map(p => parseInt(p)) || []
                        let bedIds = d.dic_recovery_bed_id && _.split(d.dic_recovery_bed_id, `,`).map(p => parseInt(p)) || []
                        let orooms = []
                        let rbeds = []
                        _.forEach(this.ward_auth, ward => {
                            if (_.has(ward, `operation_room`)) {
                                let wardRoomIds = ward.operation_room.map(o => o.value)
                                let childRoomIds = roomIds.filter(x => wardRoomIds.includes(x))
                                childRoomIds.map(p => {
                                    p = `${ward.value}_${p}`
                                    orooms.push(p)
                                })
                            } else {
                                let wardBedIds = ward.recovery_bed.map(o => o.value)
                                let childBedIds = bedIds.filter(x => wardBedIds.includes(x))
                                childBedIds.map(p => {
                                    p = `${ward.value}_${p}`
                                    rbeds.push(p)
                                })
                            }
                        })
                        d.board_type && _.split(d.board_type, `,`).map(p => {
                            p = `dp_pc_${p}`
                            rbeds.push(p)
                        })

                        let wards = orooms.concat(rbeds)
                        d.dic_ward_ids = wards

                        d.sys_messagegroup_ids = d.sys_messagegroup_ids && _.split(d.sys_messagegroup_ids, `,`).map(p => parseInt(p))
                        let users = d.ac_sysUser_ids && _.split(d.ac_sysUser_ids, `,`).map(p => parseInt(p))
                        if (users && users.length == 1 && users[0] == 0) {
                            d.ac_sysUser_ids = []
                            d.all = true
                        } else {
                            d.all = false
                            d.ac_sysUser_ids = users
                        }

                        d.modify_date = this.$moment(d.modify_date).format(`YYYY/MM/DD HH:mm`)
                    })

                    data = _.filter(data, r => {
                        return r.send_type && r.send_type > 0
                    })
                    if (that.dic_ward_id) {
                        data = _.filter(data, r => {
                            return _.includes(r.dic_ward_ids, that.dic_ward_id) || r.send_type == 2
                        })
                    }

                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        addMessageTemplate({ row }) {
            this.messageTemplateView.data = {}
            if (row) {
                this.messageTemplateView.data = row
            }
            this.messageTemplateView.title = `创建`
            this.messageTemplateView.columnList = _.filter(this.columnList, d => {
                return d.isCreatable || d.sendType == 1
            })
            this.messageTemplateView.dialogFormVisible = true
        },
        saveOne(row) {
            return new Promise((resolve, reject) => {
                let data = {
                    id: row && row.id || 0,
                    name: row.name,
                    title: row.title,
                    content: row.content,
                    send_type: row.send_type
                }

                if (row.send_type == 1) {
                    let dicoperatingwardid = []
                    let dicoperatingroomid = []
                    let dicrecoverywardid = []
                    let dicrecoverybedid = []
                    let boardtype = ``

                    row.dic_ward_ids.map(item => {
                    // item 格式为 rw_手术区id_手术间id
                        let itemarr = item.split(`_`)
                        let pitemvalue = parseInt(itemarr[1])
                        let itemvalue = parseInt(itemarr[2])
                        if (item.indexOf(`dp`) > -1) {
                            boardtype = itemvalue
                        } else if (item.indexOf(`ow`) > -1) {
                            if (!dicoperatingroomid.includes(itemvalue)) {
                                dicoperatingroomid.push(itemvalue)
                            }
                            if (!dicoperatingwardid.includes(pitemvalue)) {
                                dicoperatingwardid.push(pitemvalue)
                            }
                        } else if (item.indexOf(`rw`) > -1) {
                            if (!dicrecoverybedid.includes(itemvalue)) {
                                dicrecoverybedid.push(itemvalue)
                            }
                            if (!dicrecoverywardid.includes(pitemvalue)) {
                                dicrecoverywardid.push(pitemvalue)
                            }
                        }
                    })
                    data.dic_operating_ward_id = _.join(dicoperatingwardid, `,`)
                    data.dic_operating_room_id = _.join(dicoperatingroomid, `,`)
                    data.dic_recovery_ward_id = _.join(dicrecoverywardid, `,`)
                    data.dic_recovery_bed_id = _.join(dicrecoverybedid, `,`)
                    data.board_type = boardtype
                    data.play_time = row.play_time
                    data.play_interval = row.play_interval
                    if (row && row.id) {
                        data.sys_messagegroup_ids = ``
                        data.ac_sysUser_ids = ``
                    }
                } else {
                    let gs = _.filter(this.usergroup, d => row.sys_messagegroup_ids && row.sys_messagegroup_ids.indexOf(d.value) > -1)
                    gs = _.flatMap(gs, d => d.ac_sys_user_id)
                    if (row.ac_sysUser_ids && row.ac_sysUser_ids.length > 0) {
                        gs = gs.concat(row.ac_sysUser_ids)
                    }
                    gs = _.uniq(gs)
                    if (!row.all && gs.length == 0) {
                        this.$message.warning(`请选择接收人`)
                    }
                    let messagegroupIds = (row.all || !row.sys_messagegroup_ids) ? null : _.join(row.sys_messagegroup_ids, `,`)
                    let sysUserIds = row.all ? [0] : gs
                    data.sys_messagegroup_ids = messagegroupIds
                    data.ac_sysUser_ids = _.join(sysUserIds, `,`)
                    if (row && row.id) {
                        data.dic_operating_ward_id = ``
                        data.dic_operating_room_id = ``
                        data.dic_recovery_ward_id = ``
                        data.dic_recovery_bed_id = ``
                        data.board_type = ``
                        data.play_time = -2147483648
                        data.play_interval = -2147483648
                    }
                }

                let req
                if (row && row.id) {
                    req = this.myaxios.put(`/api/AcisSystem/BoardTemplate/put`, data)
                } else {
                    req = this.myaxios.post(`/api/AcisSystem/BoardTemplate/post`, data)
                }
                req.then(data => {
                    this.$refs[`message_template`].ReloadListData()
                    this.messageTemplateView.dialogFormVisible = false
                    resolve(data)
                }).catch(e => {
                    reject(e)
                    console.log(e)
                })
            })
        },
        changeShowColumnList(sendType) {
            this.messageTemplateView.columnList = _.filter(this.columnList, d => {
                return d.isCreatable || d.sendType == sendType
            })
        },
        editMessageTemplate({ row }) {
            this.messageTemplateView.data = {}
            if (row) {
                this.messageTemplateView.data = row
            }
            this.messageTemplateView.title = `编辑`
            this.messageTemplateView.columnList = _.filter(this.columnList, d => {
                return d.isEditable || d.sendType == row.send_type
            })
            this.messageTemplateView.dialogFormVisible = true
        }
    },
    watch: {
        dic_ward_id: function() {
            this.$refs[`message_template`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Message/MessageTemplate.vue